import React from "react";
import styled from "styled-components";
import "../../../fonts/font.css";

import decreaseIcon from "../../../images/decrease_icon.png";
import increaseIcon from "../../../images/increase_icon.png";

export const SolutionWrapper = styled.div`
  width: 100%;
  height: 100%;

  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`;

export const SolutionContentsWrapper = styled.div`
  width: 100%;
  height: 55%;

  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`;

export const DashLine = styled.hr`
  width: 100%;
  border-top: 2px dashed #c7c7c7;
  margin-top: 40px;
  margin-bottom: 40px;
`;

export const Badge = styled.div`
  width: ${(props) => props.width || 85}px;
  height: ${(props) => props.height || 28}px;

  background: ${(props) => props.color};

  border: 1px solid ${(props) => props.borderColor};
  border-radius: 100px;

  display: flex;
  align-items: center;
  justify-content: center;

  margin-right: ${(props) => props.marginRight}px;
  margin-left: ${(props) => props.marginLeft}px;
`;

export const BadgeText = styled.div`
  font-family: Noto Sans KR;
  font-style: normal;
  font-weight: bold;
  font-size: ${(props) => props.fontSize || 12}px;
  line-height: 14px;
  text-align: center;
  color: ${(props) => props.fontColor};
  margin-top: 3px;
  margin-left: ${(props) => props.marginLeft}px;
`;

export const BadgeIcon = styled.img`
  width: ${(props) => props.iconWidth}px;
  height: ${(props) => props.iconHeight}px;
  margin-left: ${(props) => props.iconMarginLeft}px;
`;

export function TrafficBadges({
  borderColor,
  fontColor,
  iconHeight,
  iconWidth,
  src,
  badgeText,
  bname,
  marginLeft,
}) {
  return (
    <Badge
      width="140"
      height="35"
      color="#FDF3EE"
      borderColor="#EF8A57"
      marginRight="8"
    >
      <BadgeText fontSize="18" fontColor="#EF8A57" marginLeft={marginLeft}>
        {badgeText} → {bname}
      </BadgeText>
      <BadgeIcon width={iconWidth} height={iconHeight} src={src}></BadgeIcon>
    </Badge>
  );
}

export function BnameBadges({
  iconHeight,
  iconWidth,
  src,
  badgeText,
  bname,
  marginLeft,
}) {
  return (
    <Badge
      width="105"
      height="35"
      color="#FDF3EE"
      borderColor="#EF8A57"
      marginRight="8"
    >
      <BadgeText fontSize="18" fontColor="#EF8A57" marginLeft={marginLeft}>
        {bname}
      </BadgeText>
      <BadgeIcon width={iconWidth} height={iconHeight} src={src}></BadgeIcon>
    </Badge>
  );
}

export function IncreaseBadges({

  increaseNum,
  marginLeft,
  type
}) {
  return (
    <Badge
      width="85"
      height="25"
      color="#FDF3EE"
      borderColor="#EF8A57"
      marginRight="8"
    >
      <BadgeText fontSize="12" fontColor="#EF8A57" marginLeft={marginLeft}>
        {type} {increaseNum}%
      </BadgeText>
      <BadgeIcon width="11" height="14" src={increaseIcon} iconMarginLeft="3"></BadgeIcon>
    </Badge>
  );
}
export function DecreaseBadges({

  decreaseNum,
  marginLeft,
  type
}) {
  return (
    <Badge
      width="85"
      height="25"
      color="#F2F4FD"
      borderColor="#5779EF"
      marginRight="8"
    >
      <BadgeText fontSize="12" fontColor="#5779EF" marginLeft={marginLeft}>
        {type} {decreaseNum}%
      </BadgeText>
      <BadgeIcon width="11" height="14" src={decreaseIcon} iconMarginLeft="3"></BadgeIcon>
    </Badge>
  );
}

export function SameBadges({
    marginLeft,
    type
  }) {
    return (
      <Badge
        width="85"
        height="25"
        color="#F8F9F9"
        borderColor="#8F8F8F"
        marginRight="8"
      >
        <BadgeText fontSize="12" fontColor="#8F8F8F" marginLeft={marginLeft}>
          {type} 동결
        </BadgeText>
      </Badge>
    );
  }

  export function NewBadges({

    marginLeft,
  }) {
    return (
      <Badge
        width="70"
        height="25"
        color="rgba(242, 201, 76, 0.1)"
        borderColor="#F2C94C"
        marginLeft="3"
      >
        <BadgeText fontSize="12" fontColor="#F2C94C" marginLeft={marginLeft}>
          NEW!
        </BadgeText>
      </Badge>
    );
  }

export const LineWrapper = styled.div`
  width: 100%;
  height: 100%;

  display: flex;
  align-items: center;
  justify-content: center;
`;

export const Title = styled.div`
  font-family: Noto Sans KR;
  font-style: normal;
  font-weight: 700;
  font-size: 18px;
  line-height: 26px;

  color: #000000;

  span {
    font-style: normal;
    font-weight: normal;
    font-size: 15px;
    line-height: 26px;

    color: #000000;
  }
`;

export const TitleIcon = styled.img`
  width: ${(props) => props.iconWidth || 15}px;
  height: ${(props) => props.iconHeight || 14}px;
  margin-right: ${(props) => props.iconMarginRight || 5}px;
`;

export const Cost = styled.div`
  font-family: Noto Sans KR;
  font-style: normal;
  font-weight: 700;
  font-size: 18px;
  line-height: 26px;

  margin-left : ${(props) => props.marginLeft||100}px;
  margin-right: 10px;

  color: #000000;
`;